// src/components/common/commonStyles.js
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import MDTypography from "components/MDTypography";

export const selectSx = (width = "12rem") => ({
  width: { xs: "100%", sm: width },
  minHeight: "2.73rem",
  borderRadius: "0.4285rem",
  "& .MuiOutlinedInput-root": {
    borderRadius: "0.4285rem",
    minHeight: "2.73rem",
    padding: 0,
    display: "flex",
    alignItems: "center",
    "& fieldset": { borderColor: "#d0d7de" },
    // "&:hover fieldset": { borderColor: "#0654a2" },
    "&.Mui-focused fieldset": {
      borderColor: "#0654a2",
      // boxShadow: "0 0 0 0 rgba(0,123,255,.25)",
    },
  },
  "& .MuiSelect-select": {
    padding: "0 0.75rem",
    display: "flex",
    alignItems: "center",
    fontSize: "1rem",
    justifyContent: "space-between", // arrow stays on right
    position: "relative",
    textTransform: "capitalize",
  },
  "& .MuiSelect-icon": {
    right: "0.5rem",
    color: "#6c757d",
    display: "block",
    transform: "scale(1.8)", // scale 50% bigger
  },
  "& .MuiMenuItem-root": {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem", // badge + text spacing
  },
});

export const radioLabelSx = {
  "& .MuiFormControlLabel-label": {
    fontWeight: "normal",
    fontSize: "1.2rem",
  },
};

export const selectMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 170, // shows ~5 items
      overflowY: "auto",
      borderRadius: "0.5rem",
      mt: 0.5, // small spacing below select
    },
  },
};

export const autoCompleteProps = {
  disablePortal: true,
  ListboxProps: {
    sx: {
      maxHeight: 170,
      overflowY: "auto",
    },
  },
};

export const authorizedUser = (res) => {
  if (res?.code === 440) {
    localStorage.clear();
    window.location.href = `/auth/login?error=Your session has expired`;
  } else {
    return;
  }
};

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#e0e0e0",
    borderRadius: 1,
    transition: "all 0.3s ease",
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundImage: `linear-gradient(90deg, ${theme.palette.deepBlue.main}, ${theme.palette.primary.main})`,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundImage: `linear-gradient(90deg, ${theme.palette.success.main}, ${theme.palette.success.main})`,
  },
}));

export const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: "#e0e0e0",
  zIndex: 1,
  color: "#fff",
  width: 55,
  height: 55,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 0.3s ease",
  ...(ownerState.completed &&
    !ownerState.active && {
      backgroundImage: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.success.main})`,
    }),
  ...(ownerState.active &&
    ownerState.hasValue && {
      backgroundImage: `linear-gradient(135deg, ${theme.palette.lightdeepBlue.main}, ${theme.palette.primary.main})`,
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      transform: "scale(1.05)",
    }),
  ...(ownerState.active &&
    !ownerState.hasValue && {
      backgroundImage: `linear-gradient(135deg, ${theme.palette.lightdeepBlue.main}, ${theme.palette.primary.main})`,
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      transform: "scale(1.05)",
    }),
}));

const cardThemes = [
  { bg: "#E8F5E9", border: "#2E7D32" }, // Green
  { bg: "#E3F2FD", border: "#1565C0" }, // Blue
];

export const getCardStyle = (isSelected, stepIndex, variant = null) => {
  const theme = cardThemes[stepIndex % 2];

  return {
    p: 2,
    cursor: "pointer",
    borderRadius: 2,
    border: isSelected
      ? `2px solid ${theme.border}`
      : `1px solid ${theme.border}`,
    backgroundColor: isSelected ? theme.border : theme.bg,
    color: isSelected ? "#fff" : "inherit",
    boxShadow: isSelected ? "0 8px 20px rgba(0,0,0,0.25)" : "none",
    transform: isSelected ? "scale(1.03)" : "scale(1)",
    transition: "all 0.25s ease",
    "& .MuiTypography-root": {
      color: isSelected ? "#fff !important" : `${theme.border} !important`,
      fontWeight: 600,
    },
    "& .MuiSvgIcon-root": {
      color: isSelected ? "#fff !important" : `${theme.border} !important`,
    },
    "&:hover": {
      transform: "translateY(-4px) scale(1.02)",
      boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
    },
  };
};

export const renderHeader = (title) => (
  <MDTypography
    sx={{
      fontSize: "1rem",
      fontWeight: 600,
      whiteSpace: "nowrap",
      display: "inline-flex",
      alignItems: "left",
      gap: "4px",
    }}
  >
    {title}
  </MDTypography>
);


export const ISOToDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

const PASSWORD_SALT = "G8sK8xNm0qAr2zY6";
export const encodePassword = (password) => {
  const salted = PASSWORD_SALT + password;
  return btoa(salted); // Convert the salted string into Base64 format
};
